module.exports = __webpack_public_path__ + "static/img/855.5ce645d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/855.jpg
// module id = JpMi
// module chunks = 0